<div class="page tracking content">
  <app-left-track [trackingMode]="true" [visibleComponents]="'objects'"></app-left-track>

  <div class="vert_collapser" id="vert_collapser" onclick="collapseTrack()">
    <span><i></i></span>
  </div>

  <div class="righttrack">
    <div class="bottomright" id="bottomright">
      <div class="navblock">
        <div>
          <button class="btnadd">{{'Add completed work' | translate}}</button>
        </div>
        <div></div>
        <div class="inputgroup">
          <input class="dtpickerupleft" type="text" value="">
        </div>
        <button id="setintervalbtn" class="btn_blue">{{'Apply'|translate }}</button>
      </div>
      <div class="rightreport">
        <div id="servicetasks_info" class="tablewrap resizetable tabpage">
          <div class="table">
            <table fixedcols="[5]" id="completedworkstable">
              <tr>
                <th>{{'Completed work'|translate }}</th>
                <th>{{'Object'|translate }}</th>
                <th>{{'Date'|translate }}</th>
                <th>{{'Service task'|translate }}</th>
                <th>{{'Cost'|translate }}</th>
                <th></th>
              </tr>
            </table>
          </div>
          <app-pagination [viewmode]="'print excel reports'" [printElementID]="'completedworkstable'"></app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
